import m from 'mithril'
import { initMithrilComponent } from '@client-shared/utils/mithril'

const CheckmarkIcon = initMithrilComponent()
CheckmarkIcon.view = () =>
	m(
		'svg',
		Object.assign({
			viewBox: '0 0 8 6',
			fill: 'none',
			'aria-hidden': 'true',
			style: 'width: var(--icon-width, 8px); height: var(--icon-height, 6px);',
		}),
		m('path', { d: 'M1 2.5L3 4.5L7 1', stroke: 'var(--icon-color, currentColor)' }),
	)

export default CheckmarkIcon
